import { useEffect } from "react";
import { useParams } from "react-router-dom";
import TimerOff from "@material-ui/icons/TimerOff";
import Domain from "@material-ui/icons/Domain";
import Form from "./form";
import { useBreadcrumbs } from "../../../../../../../../../../../../../contexts/breadcrumb";
import { useAttendanceLocalDepartmentQueueServiceTimeExceptionCreate } from "../../../../../../../../../../../../../services/api-tansquery/attendance-local/department/queue/service-time/exception/create";

export default function FormCreate() {
    const { setBreadcrumbs } = useBreadcrumbs();
    const { slug, department_id, queue_id } = useParams<{ slug: string; department_id: string; queue_id: string; }>();
    const mutation = useAttendanceLocalDepartmentQueueServiceTimeExceptionCreate();

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Locais de Atendimento",
                    path: "/locais-de-atendimento",
                    icon: Domain,
                },
                {
                    label: "Setor",
                    path: `/locais-de-atendimento/${slug}/setor/${department_id}`,
                    icon: Domain,
                },
                {
                    label: "Exceção de Horarios (Serviços)",
                    path: `/locais-de-atendimento/${slug}/setor/${department_id}/fila/${queue_id}/excecao-tempo-servicos`,
                    icon: TimerOff
                },
                {
                    label: "Gerenciar",
                    path: "",
                }
            ];
        });
    }, [setBreadcrumbs, slug, department_id, queue_id]);

    return (
        <Form
            queueId={Number(queue_id)}
            departmentId={Number(department_id)}
            mutation={mutation}
        />
    );
}
